module.exports = __webpack_public_path__ + "img/therapy.b7305ef7.svg";